import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreCheckoutVeiculoService {

  placas = new BehaviorSubject<any[]>(new Array<any>());
  value = new BehaviorSubject<ValuesVeiculo>(new ValuesVeiculo());
  constructor() { }

  public setValue(value: ValuesVeiculo): void {
    this.value.next(value);
  }

  public getValues(): Observable<ValuesVeiculo> {
    return this.value.asObservable();
  }

  public setPlacas(value: any[]): void {
    this.placas.next(value);
  }

  public getPlacas(): Observable<any[]> {
    return this.placas.asObservable();
  }
}

export class ValuesVeiculo{
  constructor(
    showPlaca: boolean = true,
    showSinal: boolean = false,
    showSensorEngate: boolean = false,
    showSensorBau: boolean = false,
    showAlvoOrigem: boolean = false,
    showMacroInicioViagem: boolean = false
  ){

    this.showPlaca = showPlaca;
    this.showSinal = showSinal;
    this.showSensorEngate = showSensorEngate;
    this.showSensorBau = showSensorBau;
    this.showAlvoOrigem = showAlvoOrigem;
    this.showMacroInicioViagem = showMacroInicioViagem;
  }

  showPlaca: boolean;
  showSinal: boolean;
  showSensorEngate: boolean;
  showSensorBau: boolean;
  showAlvoOrigem: boolean;
  showMacroInicioViagem: boolean;
}